import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_APPROVALPERSONS } from "../../../../utils/constants";
import { ApprovalPersonInterface } from "../../../../models/ProcurementModule/ApprovalPerson";
import approvalPersonService from "../../../../services/procurementService/approvalPersonService";

interface AddApprovalPersonContext {
  previousApprovalPersons: ApprovalPersonInterface[];
}

const useAddApprovalPerson = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    ApprovalPersonInterface,
    Error,
    ApprovalPersonInterface,
    AddApprovalPersonContext
  >({
    mutationFn: approvalPersonService.Create,

    onMutate: () => {
      const previousApprovalPersons =
        queryClient.getQueryData<ApprovalPersonInterface[]>([
          CACHE_KEY_APPROVALPERSONS,
          page,
          pageSize,
        ]) || [];

      return { previousApprovalPersons };
    },

    onSuccess: (savedApprovalPerson) => {
      queryClient.setQueryData<ApprovalPersonInterface[]>(
        [CACHE_KEY_APPROVALPERSONS, page, pageSize],
        (approvalPerson) => {
          const updatedApprovalPersons = approvalPerson
            ? [savedApprovalPerson, ...approvalPerson]
            : [savedApprovalPerson];
          return updatedApprovalPersons.sort((a, b) => {
            if (
              a.purchaseOrderType?.title &&
              b.purchaseOrderType?.title &&
              a.purchaseOrderType?.title !== b.purchaseOrderType?.title
            ) {
              return a.purchaseOrderType?.title.localeCompare(
                b.purchaseOrderType?.title
              );
            }
            return a.order - b.order;
          });
        }
      );
    },

    onError: (error, newApprovalPerson, context) => {
      if (!context) return;

      queryClient.setQueryData<ApprovalPersonInterface[]>(
        [CACHE_KEY_APPROVALPERSONS, page, pageSize],
        context.previousApprovalPersons
      );
    },
  });
};

export default useAddApprovalPerson;
